/**
 * day-ritual-storage.util — S3 Abertura e Fechamento do dia (Corrente de
 * Compromissos, P2 da tese). Persistência client-side do `lastRitualAt`
 * (design §4 — sem tabela nova, v1 é localStorage por-usuário).
 *
 * Puro (exceto o próprio acesso a `window.localStorage`, isolado nas 2
 * funções de leitura/escrita) — fail-soft: modo privado/quota estourada não
 * quebra o painel, só desativa o auto-open (comportamento honesto: sem
 * memória, reabre sempre).
 */

export function dayRitualLastOpenKey(userId: string): string {
  return `lume.dayRitual.lastOpen.${userId}`;
}

export function readLastRitualOpen(userId: string): string | null {
  try {
    return window.localStorage.getItem(dayRitualLastOpenKey(userId));
  } catch {
    return null;
  }
}

export function writeLastRitualOpen(userId: string, iso: string): void {
  try {
    window.localStorage.setItem(dayRitualLastOpenKey(userId), iso);
  } catch {
    // localStorage indisponível (modo privado/quota) — falha silenciosa.
  }
}

/**
 * Decide se o rito de Abertura deve auto-abrir: `lastOpenIso` ausente/inválido
 * OU de um dia calendário (UTC) diferente de `nowMs`. 1×/dia por operador.
 */
export function shouldAutoOpenToday(lastOpenIso: string | null, nowMs: number): boolean {
  if (lastOpenIso === null) return true;
  const last = new Date(lastOpenIso);
  if (Number.isNaN(last.getTime())) return true;
  const now = new Date(nowMs);
  return (
    last.getUTCFullYear() !== now.getUTCFullYear() ||
    last.getUTCMonth() !== now.getUTCMonth() ||
    last.getUTCDate() !== now.getUTCDate()
  );
}
